"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSupplyPointsLegacyQuery = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var core_1 = require("../../../core");
function useSupplyPointsLegacyQuery(accountId, options) {
    var api = core_1.configService.getConfig().api;
    var supplyPointsEndpoint = "".concat(api.baseUrl, "/orex/api/supply-points/account/").concat(accountId);
    return (0, ui_tools_1.useReactQuery)("cx-supply-points-".concat(accountId), function () {
        return core_1.apiService.get({
            url: supplyPointsEndpoint,
            headers: { 'orion-endpoint-version': '2' },
        });
    }, options);
}
exports.useSupplyPointsLegacyQuery = useSupplyPointsLegacyQuery;
